module.exports = __webpack_public_path__ + "static/clock-10f0652d413bc4d33d26dc8d51942e20.wav";